/**
 * Material rounded star glyphs — Figma 5074-13455 (filled) / 5074-13453 (outline).
 * Paths match Sensemaker rating live preview (`StarRounded` / `StarOutlineRounded`).
 */
import SvgIcon, { type SvgIconProps } from '@mui/material/SvgIcon'
import { surveyExecPrimary } from '../../styles/surveyExecutionStyles'

/** Figma survey execution rating star — enlarged tap target (56×56px). */
export const SURVEY_RATING_STAR_SIZE_PX = 56

const STAR_FILLED_PATH =
  'm12 17.27 4.15 2.51c.76.46 1.69-.22 1.49-1.08l-1.1-4.72 3.67-3.18c.67-.58.31-1.68-.57-1.75l-4.83-.41-1.89-4.46c-.34-.81-1.5-.81-1.84 0L9.19 8.63l-4.83.41c-.88.07-1.24 1.17-.57 1.75l3.67 3.18-1.1 4.72c-.2.86.73 1.54 1.49 1.08z'

const STAR_OUTLINE_PATH =
  'm19.65 9.04-4.84-.42-1.89-4.45c-.34-.81-1.5-.81-1.84 0L9.19 8.63l-4.83.41c-.88.07-1.24 1.17-.57 1.75l3.67 3.18-1.1 4.72c-.2.86.73 1.54 1.49 1.08l4.15-2.5 4.15 2.51c.76.46 1.69-.22 1.49-1.08l-1.1-4.73 3.67-3.18c.67-.58.32-1.68-.56-1.75M12 15.4l-3.76 2.27 1-4.28-3.32-2.88 4.38-.38L12 6.1l1.71 4.04 4.38.38-3.32 2.88 1 4.28z'

export interface SurveyRatingStarIconProps extends SvgIconProps {
  readonly filled: boolean
}

export function SurveyRatingStarIcon({
  filled,
  sx,
  ...props
}: Readonly<SurveyRatingStarIconProps>) {
  return (
    <SvgIcon
      {...props}
      viewBox="0 0 24 24"
      sx={{
        fontSize: SURVEY_RATING_STAR_SIZE_PX,
        width: SURVEY_RATING_STAR_SIZE_PX,
        height: SURVEY_RATING_STAR_SIZE_PX,
        color: surveyExecPrimary,
        display: 'block',
        flexShrink: 0,
        ...sx,
      }}
    >
      <path d={filled ? STAR_FILLED_PATH : STAR_OUTLINE_PATH} />
    </SvgIcon>
  )
}
